import { useModal } from "../utils/ModalContext";
import GlobalStyles from "../assets/styles/GlobalStyles";
import Layout from "../common/layout";
import Header from "../components/section/header/v1/Header";
import PageHeader from "../common/pageHeader/v5";
import Register from "../components/section/register";
import CTA from "../components/section/cta/v2";
import Footer from "../components/section/footer/v5";
import MetamaskModal from "../common/modal/metamaskModal/MetamaskModal"; 
import WalletModal from "../common/modal/walletModal/WalletModal";
const RegisterPage = () => {
  const { walletModalvisibility, metamaskModal} =
    useModal();
  return (
    <>
      <Layout>
        <GlobalStyles /> 
        <Header />
        <Register />
        <Footer />
      </Layout>
    </>
  );
};

export default RegisterPage;
